import { render, staticRenderFns } from "./BTextField.vue?vue&type=template&id=03dcdb3a"
import script from "./BTextField.vue?vue&type=script&lang=js"
export * from "./BTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports